
export default ({from, property, value}) => {
  let selected = (from.filter((item) => {
    return item[property] === value;
  }));
  if (selected.length > 0) {
    return selected[0];
  }
  return false;
}